import copy from './locales.json';

export const languageStorageKey = 'turbokiller-language';
export const languages = [
  {
    "value": "en",
    "label": "English"
  },
  {
    "value": "zh-CN",
    "label": "简体中文"
  },
  {
    "value": "zh-TW",
    "label": "繁體中文"
  },
  {
    "value": "ja",
    "label": "日本語"
  },
  {
    "value": "ko",
    "label": "한국어"
  },
  {
    "value": "de",
    "label": "Deutsch"
  },
  {
    "value": "fr",
    "label": "Français"
  },
  {
    "value": "es",
    "label": "Español"
  },
  {
    "value": "pt-BR",
    "label": "Português (Brasil)"
  },
  {
    "value": "pt-PT",
    "label": "Português (Portugal)"
  },
  {
    "value": "it",
    "label": "Italiano"
  },
  {
    "value": "ru",
    "label": "Русский"
  },
  {
    "value": "tr",
    "label": "Türkçe"
  },
  {
    "value": "id",
    "label": "Bahasa Indonesia"
  },
  {
    "value": "vi",
    "label": "Tiếng Việt"
  },
  {
    "value": "ar",
    "label": "العربية"
  },
  {
    "value": "he",
    "label": "עברית"
  }
];

export function matchLanguage(value) {
  const tag = (value || '').replace(/_/g, '-').toLowerCase();
  const exact = languages.find(({ value }) => value.toLowerCase() === tag);
  if (exact) return exact.value;
  if (/^zh-(tw|hk|mo|hant)(-|$)/.test(tag)) return 'zh-TW';
  if (/^zh(-|$)/.test(tag)) return 'zh-CN';
  if (/^pt-br(-|$)/.test(tag)) return 'pt-BR';
  if (/^pt(-|$)/.test(tag)) return 'pt-PT';
  if (/^iw(-|$)/.test(tag)) return 'he';
  return languages.find(({ value }) => value === tag.split('-')[0])?.value;
}

export function detectLanguage() {
  const linked = new URLSearchParams(window.location.search).get('lang');
  if (linked && copy[linked]) return linked;
  try {
    const saved = localStorage.getItem(languageStorageKey);
    if (saved && copy[saved]) return saved;
  } catch { /* Private browsing can disable storage. */ }
  const preferences = navigator.languages?.length ? navigator.languages : [navigator.language];
  return preferences.map(matchLanguage).find(Boolean) || 'en';
}
